import { useEffect, useRef, useState } from 'react';
import { Api } from '../../services/api';
import { Modal } from '../../Components/Modal';
import { CargaModal } from '../../Components/CargaModal';
import { CanhotoCanvas } from '../../Components/CanhotoCanvas';
import { OffCanvas } from '../../Components/OffCanvas';
import { ModalCanhoto } from '../../Components/ModalCanhoto';

export const Carga = () => {
  const [cargas, setCargas] = useState(null);
  const [cargaSelected, setCargaSelected] = useState(null);
  const [tokenSearch, setTokenSearch] = useState(null);
  const [idCanhoto, setIdCanhoto] = useState(null);
  const [updateModal, setUpdateModal] = useState(false);
  const inputToken = useRef(null);

  const [isModalOpen, setModalOpen] = useState(false);

  const findAllCargas = async () => {
    try {
      const carga = await Api.get('/carga');
      console.log(carga);
      setCargas(carga.data);
    } catch (e) {
      setCargas(null);
    }
  };

  const handleClickSearchToken = async () => {
    const id = inputToken.current.value;
    try {
      const token = await Api.get(`/token/${id}`);

      console.log(token);

      setTokenSearch(token.data);
      tokenSearch;
    } catch (e) {
      setTokenSearch(null);
    }
  };

  const handleClickAtribuirCarga = async () => {
    try {
      await Api.post(`/token/carga/${cargaSelected}`, {
        id: inputToken.current.value,
      });

      alert('Carga atribuida com sucesso!');
      setTokenSearch(null);
      inputToken.current.value = '';
    } catch (e) {
      console.log(e.message);
    }
  };

  const selectCarga = (id) => {
    setCargaSelected(null);
    setCargaSelected(id);
  };

  useEffect(() => {
    if (!isModalOpen) findAllCargas();
  }, [isModalOpen]);

  return (
    <div className="mt- 4 container">
      <div className="mt-4"></div>
      <div className="row">
        <div className="col-3">
          <button className="btn btn-success" data-bs-toggle="modal" data-bs-target="#create-carga-modal">
            Montar Carga
          </button>
        </div>
        <div className="col-3"></div>
        <div className="col-3"></div>
        <div className="col-3">
          <button className="btn btn-success" data-bs-toggle="modal" data-bs-target="#create-carga-modal">
            Atualizar Cargas
          </button>
        </div>
      </div>

      <table className="table mt-4">
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Número</th>
            <th scope="col">Status</th>
            <th scope="col">Atribuido</th>
            <th scope="col">-</th>
          </tr>
        </thead>
        <tbody>
          {cargas ? (
            cargas.map((carga) => (
              <tr key={carga.id}>
                <th scope="row">{carga.id}</th>
                <td>{carga.numero}</td>
                <td>{carga.status.descricao}</td>
                <td>{!carga.idToken ? 'Não' : 'Sim'}</td>
                <td>
                  {!carga.idToken ? (
                    <button
                      className="btn btn-success"
                      data-bs-toggle="modal"
                      data-bs-target="#atribuir-token-carga"
                      onClick={() => setCargaSelected(carga.id)}
                    >
                      Atribuir para
                    </button>
                  ) : (
                    <button
                      className="btn btn-secondary"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvas-view-carga"
                      onClick={() => selectCarga(carga.id)}
                    >
                      Ver status
                    </button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <td>Não foi encontrado nenhum token</td>
          )}
        </tbody>
      </table>

      <Modal
        data={{
          ref: 'atribuir-token-carga',
          title: 'Atribuir um token a carga',
          isModalOpen: setModalOpen,
        }}
      >
        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Pesquise pelo número do token"
            aria-label="Pesquise pelo número do token"
            aria-describedby="button-addon2"
            ref={inputToken}
          />
          <button
            className="btn btn-outline-secondary"
            type="button"
            id="button-addon2"
            onClick={handleClickSearchToken}
          >
            Pesquisar
          </button>
        </div>
        <div>
          <table className="table mt-4">
            <thead>
              <tr>
                <th scope="col">Chave</th>
                <th scope="col">Motorista</th>
                <th scope="col">Transportadora</th>
                <th scope="col">Descrição</th>
                <th scope="col">-</th>
              </tr>
            </thead>
            <tbody>
              {tokenSearch ? (
                <tr key={tokenSearch.id}>
                  <th scope="row">{tokenSearch.id}</th>
                  <td>{tokenSearch.motorista}</td>
                  <td>{tokenSearch.transportadora}</td>
                  <td>{tokenSearch.descricao}</td>
                  <td>
                    <button className="btn btn-success" onClick={handleClickAtribuirCarga}>
                      👍
                    </button>
                  </td>
                </tr>
              ) : (
                <tr key={1}>
                  <th scope="row">-</th>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>
                    <button className="btn btn-success" onClick={handleClickAtribuirCarga}>
                      -
                    </button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Modal>

      <Modal data={{ ref: 'create-carga-modal', title: 'Criar Token de acesso', isModalOpen: setModalOpen }}>
        <CargaModal />
      </Modal>

      <OffCanvas data={{ key: 'view-carga', title: 'Status da Carga' }}>
        {cargaSelected && (
          <CanhotoCanvas carga={cargaSelected} setCanhoto={setIdCanhoto} setUpdateModal={setUpdateModal} />
        )}
      </OffCanvas>

      <ModalCanhoto id={idCanhoto} update={updateModal} isUpdated={setUpdateModal} />
    </div>
  );
};
